import React from 'react';
import css from '../../Campaigns/style.scss';

const EndDialerCampaignConfirmationModal = ({open, onCancel, onConfirm, disable}) => {
  if (!open) return null;

  return (
    <div className={css.dialerCampaignModalBackdrop} onClick={onCancel}>
      <div className={css.dialerCampaignModalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={css.dialerCampaignHeaderContainer}>
          <div className={css.dialerCampaignEndBtnHeader}>End Dialer Campaign Activity</div>
          <div className={css.dialerCampaignEndBtnContent}>
            Ending this Dialer Campaign Activity will disable all actions.
            You can duplicate the activity afterward if needed.
          </div>
        </div>
        <div className={css.dialerCampaignModalActions}>
          <button className={css.dialerCampaignCancelBtn} onClick={onCancel}>
            Cancel
          </button>
          <button className={css.dialerCampaignEndBtn} onClick={onConfirm} disabled={disable}>
            End Activity
          </button>
        </div>
      </div>
    </div>
  );
};

export default EndDialerCampaignConfirmationModal;
